export const COMPARE = '@compare';

export enum CompareCarTypeEnum {
  NEW = 'new',
  USED = 'used',
  PRIVATE_LEASING = 'privateLeasing',
}
